function myformatTime(num) {
    let date1 = new Date();
    let date2 = new Date(date1);
    date2.setDate(date1.getDate() + num);
    //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
   // const time = `${date2.getFullYear()}-${(date2.getMonth() + 1) < 10 ? '0'+ (date2.getMonth() + 1): (date2.getMonth() + 1) }-${date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate()  } ${date2.getHours() < 10 ? '0' + date2.getHours() : date2.getHours()}:${date2.getMinutes() < 10 ? '0' + date2.getMinutes() : date2.getMinutes()}:${date2.getSeconds() < 10 ? '0' + date2.getSeconds() : date2.getSeconds()}`
    //console.log(time2);
    const time = `${date2.getFullYear()}-${(date2.getMonth() + 1) < 10 ? '0'+ (date2.getMonth() + 1): (date2.getMonth() + 1) }-${date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate()  }`
    return time;
}

module.exports = myformatTime
